export const getMobileRedirectPath = (search = '', storage = localStorage) => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  const uuidFromQuery = params.get('uuid');
  const uuidFromStorage = storage?.getItem?.('pendingUuid');
  const uuid = uuidFromQuery || uuidFromStorage;

  return uuid ? `/mobile?uuid=${encodeURIComponent(uuid)}` : '/mobile';
};
